import Contacts from '../contacts';
import ContactList from '../components/contacts/contact-list';
import ContactGroupsList from '../components/groups/group-list';
import ContactFilesList from '../components/contact-files-list';
import ContactImportExport from '../components/contact-import-export';
import { contactListLDTRoutes, contactGroupsListLDTRoutes, contactFilesListLDTRoutes, contactImportExportRoute } from './routes';
import { getDetailsTabRouteObjects } from '../../../utility/route';

export const contactsModuleRouter = [
  {
    path: '/main/contacts',
    name: 'contacts',
    component: Contacts,
    redirect: 'main/contacts/contact_list',
    children: [
      {
        name: contactImportExportRoute,
        path: 'Import_Export',
        component: ContactImportExport
      },
      ...getDetailsTabRouteObjects(contactListLDTRoutes, ContactList),
      ...getDetailsTabRouteObjects(contactGroupsListLDTRoutes, ContactGroupsList),
      ...getDetailsTabRouteObjects(contactFilesListLDTRoutes, ContactFilesList),
    ]
  }
]